GP.GPMod('PostRegistration',function(self) {
    var vent  = null;
    var _util = null;
    var _log  = null;

    var data = {
        // check and initialize a few params
        init: function() {
            vent  = self.vent;
            _util = self.app.Util;
            _log  = self.app.Util.log;

            // detect the File API (necessary for progressbar on upload)
            data.can_show_progress = !!(window.File && window.FileList);

            // if we're in FF, make sure its FF4+
            if ('MozAppearance' in document.documentElement.style && data.can_show_progress) {
                data.can_show_progress = !!(window.FormData && window.URL);
            }

            // check if we want to set the uploaded pic as primary pic (i.e. post_registration modal, etc...)
            if (typeof _modal_vars != 'undefined') {
                if (_modal_vars.hasOwnProperty('set_pic_as_primary')) {
                    data.set_pic_as_primary = !!_modal_vars.set_pic_as_primary;
                } else {
                    data.set_pic_as_primary = false;
                }
            } else {
                data.set_pic_as_primary = false;
            }

            if (typeof self_profile_view != 'undefined') {
                if (self_profile_view) {
                    data.add_pic_to_profile = true;
                }
            }
        },
        event_namespace:     'post-reg-modal',
        can_show_progress:   false,
        set_pic_as_primary:  false,
        force_private:       false,
        add_pic_to_profile:  false,
        media_type:         'image',
        is_gallery_upload:   false,
        sections:                  [
            {
                item: '#section-photos-name',
                step: '#step-photos-name'
            },
            {
                item: '#section-about-you',
                step: '#step-about-you'
            },
            {
                item: '#section-looking-for',
                step: '#step-looking-for'
            }
        ],
        sections_truncated:       [
            {
                item: '#section-photos-name',
                step: '#step-photos-name'
            },
                    ],
        section_content_rating: {
            item: '#section-content-rating',
            step: '#step-content-rating'
        },
        section_gender_age: {
            item: '#section-gender-age',
            step: '#step-gender-age'
        },
        cur_sect_index:       0,
        selected_media_item: null,
        thumb_count:         0,
        interest_count: 0,
    };

    var apis = {
        records_form_submit: function(form) {
            var url = $(form).attr('action');

            self.api.json(url, {
                data:    $(form).serialize(),
                error:   function() {},
                success: function(json) {
                    if (self.app.Util.check_obj(json.html)) {
                        $("#records").html(json.html);
                    }
                }
            });
        },
        delete_content: function($clicked) {
            var $pic_wrap = $('.pic-wrap');

            var $add_media_item = '';
            $add_media_item = $clicked.closest('.add-media-item');

            // if (data.is_gallery_upload) {
            //     $add_media_item = $clicked.closest('.add-media-item');
            // } else if (!_modal_vars.is_new_post_reg) {
            //     //delete pic in default modal (fling, etc)
            //     $add_media_item = $clicked.closest('.thumb-item');
            // } else {
            //     $add_media_item = $('.pic-wrap');
            // }

            var _content_id = $add_media_item.data('content_id');
            var api_url = '',
            input   = {};

            api_url = _util.clean_url('members/content/del_content');
            input = {
                content_id: _content_id
            };

            if (confirm(js_lang.profile_text.confirm_del)) {
                self.api.json(api_url, {
                    type: 'POST',
                    data: input
                }).done(function(json) {
                    data.thumb_count--;
                    $add_media_item.removeClass('has-media');
                    $clicked
                    .siblings('.img-preview')
                    .css('background-image', 'none');

                    if (data.thumb_count > 1) {
                        handlers.reset_nav_pics();
                    }

                    // if (data.is_gallery_upload) {
                    //     $add_media_item.removeClass('has-media');
                    //     $clicked
                    //     .siblings('.img-preview')
                    //     .css('background-image', 'none');
                    // } else if (!_modal_vars.is_new_post_reg) {
                    //     if (data.thumb_count > 1) {
                    //         $clicked.closest('.thumb-item').remove();
                    //     } else if (data.thumb_count === 1) {
                    //         $('.post-reg-content .images-wrap').removeClass('has-media');
                    //         $clicked.closest('.thumb-item')
                    //             .removeData('content_id')
                    //             .attr('data-content_id', "");
                    //         $clicked.siblings('.img-preview').css('background-image', 'url("")');
                    //         GP.sdata.my_user.has_pic = false;
                    //         handlers.reset_nav_pics();
                    //     }

                    //     data.thumb_count--;
                    // } else {
                    //     handlers.reset_nav_pics();

                    //     $("#pic-button-wrap").show();
                    //     $("#profile-pic").css('background-image', 'url("")');
                    //     $('.pic-wrap').removeClass('upload-complete');

                    //     $pic_wrap.removeData('content_id');
                    //     GP.sdata.my_user.has_pic = false;
                    // }
                }).fail(function() {
                    // error msg?
                });
            }
        }
    };

    var events = {
        setup_records_form: function() {
            $("#records-submit-btn").on('click.'+data.event_namespace, function(e) {
                e.preventDefault();

                if (!$(this).hasClass('disabled')) {
                    $("#records-form").submit();
                }
            });

            $("#records-form").on('submit.'+data.event_namespace, function(e) {
                e.preventDefault();
                var form_submit_url = $(this).attr('action');

                if (form_submit_url.length > 0) {
                    $("#records-submit-btn").text('Saving...').toggleClass('disabled');

                    apis.records_form_submit(this);
                }
                return false;
            });
        },
        // guidlines for uploading pictures
        show_upload_guidlines: function() {
            var url = '/members/info/upload_guidelines&no_header=1';
            var new_window = window.open(url, 'name', 'height=750,width=470,scrollbars=1');
            if (window.focus && new_window) {
                new_window.focus();
            }
            return false;
        },
        // guidlines for usernames
        show_username_guidlines: function() {
            var url = '/members/info/username_guidelines&no_header=1';
            var new_window = window.open(url, 'name', 'height=750,width=470,scrollbars=1');
            if (window.focus && new_window) {
                new_window.focus();
            }
            return false;
        },
        setup_pic_upload: function() {
            data.init();

            if (!data.can_show_progress) {
                $('#upload_progress_ie').css('display', 'block');
                $('#upload_progress').css('display', 'none');
                // FF < 4.0 does not allow click handler to trigger file input, so we show the ugly ass input
                $('#modal_file_input').css('position', 'relative').css('left', '0');
                $('#upload-button').css('display', 'none');
            }

            var $modal = self.app.Modal.get_modal();

            // var primary_el = document.querySelector('.btn-primary');
            // if (primary_el) {
            //     data.secondary_color_rgb = getComputedStyle(primary_el).getPropertyValue("background-color");
            // }

            // add process hidden input to form (since the file upload isn't really ajax)
            $('<input/>').attr({
                type: 'hidden',
                name: 'process',
                value: 'true'
            }).prependTo(".modal-form");

            if (window.can_upload_file) {
                // file uploader (blueimp fileupload)
                $('#modal_file_input').fileupload({
                    url: '/members/user/upload_pic/',
                    dataType:         'json',
                    type:             'POST',
                    autoUpload:       true,
                    progressInterval: 50, // default 100ms
                    bitrateInterval:  200,
                    add: function(e, upload_data) {
                        // console.log('add hook called... e: ', e);
                        // console.log('add hook called... upload_data: ', upload_data);

                        if (handlers.validate_upload(upload_data)) {
                            window._gp_pic_uploading = true;

                            upload_data.submit();
                        }
                    },
                    start: function(e) {
                        $('.error_container, .success_container').hide();
                        if (data.can_show_progress) {
                            $('#upload_progress .progress-bar').css('width', 0);
                        }
                        $('.notice_container').show();
                    },
                    progress: function(e, json) {
                        var progress = parseInt(json.loaded / json.total * 100, 10);

                        if (data.can_show_progress) {
                            // fix for firefox bug never reporting > 94% progress
                            if (progress > 94) {
                                progress = 100;
                            }
                            $('#upload_progress .progress-bar').css('width', progress + '%');
                        }
                    },
                    done: function(e, json) {
                        // console.log('done callback... json.result: ', json.result);

                        $('.notice_container').hide();
                        $('.error_container').hide();
                        if (!json || !json.hasOwnProperty('textStatus') || json.textStatus != 'success' || !json.result) {
                            // xhr error
                            $('.error_container p').remove();
                            $('.error_container').append('<p class="error">'+_modal_vars.error_messages[100]+'</p>').show();
                        } else if (json.result[0] && json.result[0].hasOwnProperty('error')) {
                            // some other error coming back from image upload backend
                            $('.error_container p').remove();
                            $('.error_container').append('<p class="error">'+json.result[0].error+'</p>').show();
                        } else {
                            // success
                            var $modal = self.app.Modal.get_modal();
                            var silver_modal = false;
                            data.thumb_count++;

                            $('.success_container').show();

                            if (!GP.sdata.my_user.has_pic) {
                                GP.sdata.my_user.has_pic = true;
                            }

                            setTimeout(function() {
                                $('.success_container').hide();
                                _modal_vars.thumb_count++;
                            }, 3500);

                            if (!$modal.hasClass('keep-buttons')) {
                                $("#pic-button-wrap").hide();
                            }

                            // replace nav thumb with new pic
                            if (data.thumb_count === 1) {
                                $("#mem-photo-t").attr('src', _modal_vars.media_url + json.result[0].S);
                                $("#mem-photo-s").attr('src', _modal_vars.media_url + json.result[0].S);
                                $("#profile-menu-link img").attr('src', _modal_vars.media_url + json.result[0].S);
                            }

                            $.each(json.result, function(index, obj) {
                                if (obj.hasOwnProperty('error')) {
                                    $('.error_container p').remove();
                                    $('.error_container').append('<p class="error">'+obj.error+'</p>').show();
                                } else {

                                    handlers.add_thumb_to_profile(obj);

                                    if ($modal.hasClass('js-silver-upgrade')) {
                                        handlers.add_thumb_to_silver_upgrade(obj);
                                    } else if ($modal.hasClass('hotornot')) {
                                        handlers.show_hotornot();
                                    }

                                    if (obj.membership_change) {
                                        GP.sdata.my_user.membership = obj.membership_change;
                                        vent.trigger('MessagePane:reset');
                                    }
                                }
                            });

                            if (!_modal_vars.is_new_post_reg) {
                                // default post reg modal
                                if (data.thumb_count < 1) {
                                    // show the first image
                                    $('.post-reg-content .images-wrap').addClass('has-media');
                                    $("#post-reg-thumb-item").attr('data-content_id', json.result[0].content_id);
                                    $("#post-reg-thumb-item .img-preview").css('background-image', 'url(' + json.result[0].url + ')');
                                } else {
                                    // show additional images
                                    var _thumb_item_copy = $('#post-reg-thumb-item').clone(true);
                                    _thumb_item_copy.find('.img-preview').css('background-image', 'url(' + json.result[0].url + ')');
                                    _thumb_item_copy
                                        .removeAttr('id')
                                        .attr('data-content_id', json.result[0].content_id)
                                        .appendTo('.post-reg-content .images-grid');
                                }
                                data.thumb_count++;
                            } else {
                                // $('.pic-wrap').addClass('upload-complete')
                                // .attr('data-content_id', json.result[0].content_id);
                                // $("#profile-pic").css('background-image', 'url(' + json.result[0].url + ')');

                                $('.btn-next-sect').removeClass('disabled');
                                handlers.show_image_preview(json.result[0].url, json.result[0].content_id);
                            }

                            // optionally set to primary
                            if (data.set_pic_as_primary) {
                                // don't set pic as primary for subsequent pic uploads
                                data.set_pic_as_primary = false;
                                vent.trigger('profile:set_primary_pic', json.result[0].content_id, json.result[0].file_md5, json.result[0].content_media_id);
                                GP.sdata.my_user.has_pic = true;
                            }

                            vent.trigger('hotpick:hide_upload_notice');
                        }
                        window._gp_pic_uploading = false;
                    }
                });
            } else {
                $('#modal_file_input').click(function(e) {
                    e.preventDefault();
                    alert(js_lang.no_file_upload);
                });
            }

            // // hooking up the upload button
            $('#upload-button').on('click.'+data.event_namespace, function(e) {
                e.preventDefault();
                e.stopPropagation();

                if ($('.pic-wrap').hasClass('upload-complete')) {
                    return;
                }

                events.remove_photo_req();

                if (data.can_show_progress) {
                    $('#upload_progress .progress-bar').css('width', 0);
                }

                data.is_gallery_upload = false;

                $('#modal_file_input').trigger('click');
                return false;
            });

            $('.add-media-item').on('click.'+data.event_namespace, function(e) {

                if ($(this).hasClass('has-media')) {
                    return;
                }

                // // User must upload a main photo before uploading additional photos.
                // if (!GP.sdata.my_user.has_pic) {
                //     events.show_photo_req();
                //     return;
                // }

                // data.is_gallery_upload = true;

                $('#modal_file_input').trigger('click');
                data.selected_media_item = $(this);
            });

            // guidlines for uploading pictures
            $('.fling-modal .upload-guidelines').on('click.'+data.event_namespace, events.show_upload_guidlines);
            // guidlines for usernames
            $('.fling-modal .username-guidelines').on('click.'+data.event_namespace, events.show_username_guidlines);

            // $('.fling-modal .modal-footer img.thumb').on('click.'+data.event_namespace, function(e) {
            //     $("#file-container").show();

            //     var thumb_url = $(this).attr('src');
            //     $("#profile-pic").css('width', 'auto').attr('src', thumb_url.replace('-S-', '-M-'));
            // });

            // delete pic
            var confirm_str = js_lang.profile_text.confirm_del;
            $('.fling-modal .modal-footer').on('click.'+data.event_namespace, '.delete-ico', function() {
                // warn user about losing silver_promo/verified_profile on deletion of last pic
                if ($('.fling-modal .modal-footer .thumb-wrapper').length === 1) {
                    if (GP.sdata.my_user.membership == 'SILVER_PROMO' && GP.sdata.my_user.verified_pic == 'Y') {
                        confirm_str = js_lang.profile_text.confirm_del_silver_verified;
                    } else if (GP.sdata.my_user.membership == 'SILVER_PROMO') {
                        confirm_str = js_lang.profile_text.confirm_del_silver;
                    } else if (GP.sdata.my_user.verified_pic == 'Y') {
                        confirm_str = js_lang.profile_text.confirm_del_verified;
                    }
                }

                if (confirm(confirm_str)) {
                    var pic_num    = $(this).siblings('img.thumb').attr('id').split('_').pop();
                    var $thumb_div = $(this).siblings('img.thumb').parent();
                    $.post(_util.clean_url('members/user/manage_pics'), { action:'remove', picnum:pic_num }, function(post_data) {
                        $thumb_div.fadeOut(300, function() { $(this).remove(); });
                        if (post_data.membership_change) {
                            GP.sdata.my_user.membership = post_data.membership_change;
                            vent.trigger('MessagePane:reset');
                        }
                    });
                }
            });
        },
        setup_range_slider: function() {
            var age_slider = document.getElementById('age-range-slider');
            var age_start  = _modal_vars.slider_age_start;
            var age_end    = _modal_vars.slider_age_end;


            noUiSlider.create(age_slider, {
                range: {
                    min: 18,
                    max: 100
                },
                step: 1,
                start: [age_start, age_end],
                connect: true,
                behaviour: 'tap-drag',
                tooltips: (_modal_vars.is_new_post_reg ? [true, true] : false),
                format: {
                    to: function(val) {
                        return parseInt(val);
                    },
                    from: function(val) {
                        return parseInt(val);
                    }
                }
            });

            age_slider.noUiSlider.on('slide', function(val) {
                $('#pr-age-min').text(val[0]);
                $('#pr-age-max').text(val[1]);

                $('#pr-input-age-start').val(val[0]);
                $('#pr-input-age-end').val(val[1]);
            });
        },
        setup_navigation: function() {
            var _photo_req_site = window._full_domain_name.match(/smokeandpoke\.com/i) || window._full_domain_name.match(/sexygamerz\.com/i);

            if (_modal_vars.show_truncated_post_reg) {
                data.sections = data.sections_truncated;
            }

            // check for gender age step (for google oauth registrations that need to fill out gender/age)
            if (document.getElementById('section-gender-age')) {
                // add to the beginning of the data.sections array
                data.sections.unshift(data.section_gender_age);
            }

            // check for content rating option step (shows for women R/X)
            if (document.getElementById('section-content-rating')) {
                data.sections.push(data.section_content_rating);
            }

            if (_photo_req_site) {
                $('.btn-next-sect').addClass('disabled');
            }

            if (_modal_vars.show_truncated_post_reg) {
                $('.btn-back-sect').hide();
                $('.btn-save-post-reg').show();
                $('.btn-next-sect').hide();
            }

            $('.btn-next-sect').on('click.'+data.event_namespace, function(e) {
                $('#fl-modal').scrollTop(0);

                // User must upload a main photo.
                if (_photo_req_site && !GP.sdata.my_user.has_pic) {
                    events.show_photo_req();
                    return;
                }

                if ($(this).hasClass('disabled')) {
                    return;
                }

                if (data.cur_sect_index == 0) {
                    vent.trigger("Modal:trigger_validate_username", function() {
                        // callback after validation
                        events.handle_next_section();
                    });

                    if ($('#validate_username_div').is(':visible')) {
                        $('.modal-form-group.username').addClass('has-error');
                        return;
                    } else {
                        handlers.remove_username_error();
                    }
                } else {
                    events.handle_next_section();
                }

                // temporary flag
                data.is_new_post_reg = true;
            });

            $('.btn-back-sect').on('click.'+data.event_namespace, function(e) {
                
                var _max_index = data.sections.length - 1;

                if (data.cur_sect_index !== 0) {
                    data.cur_sect_index = data.cur_sect_index - 1;
                }

                // display prev section
                var _prev_section = data.sections[data.cur_sect_index];
                events.display_section(_prev_section);

                $('.btn-back-sect').hide();
                $('.btn-save-post-reg').hide();
                $('.btn-next-sect').show();

                // show back button
                if (data.cur_sect_index !== 0) {
                    $('.btn-back-sect').show();
                }
            });
        },
        handle_next_section: function() {
            var _max_index = data.sections.length - 1;

            if (data.cur_sect_index !== _max_index) {
                data.cur_sect_index = data.cur_sect_index + 1;
            }

            // display next section
            var _next_section = data.sections[data.cur_sect_index];
            events.display_section(_next_section);

            // show back button
            $('.btn-back-sect').hide();
            if (data.cur_sect_index !== 0) {
                $('.btn-back-sect').show();
            }

            // show save button
            $('.btn-save-post-reg').hide();
            if (data.cur_sect_index == _max_index) {
                $('.btn-save-post-reg').show();
                $('.btn-next-sect').hide();
            }
        },
        display_section: function(_section) {
            $('.section-item').hide();

            $(_section.item).show();

            // update progress indicator
            $('.step-wrap').removeClass('current');
            $(_section.step).addClass('current');
        },
        setup_modal: function() {
            events.setup_pic_upload();
            events.setup_range_slider();
            events.setup_navigation();
            events.setup_content_rating();

            // main photo delete
            $('.js-delete').on('click.'+data.event_namespace, function(e) {
                // data.is_gallery_upload = false;
                apis.delete_content($(this));
            });

            // gallery media delete
            $('.btn-gallery-media-del').on('click.'+data.event_namespace, function(e) {
                // data.is_gallery_upload = true;
                apis.delete_content($(this));
            });

            // delete thumbs in default post reg modal
            $('.btn-media-del').on('click.'+data.event_namespace, function(e) {
                // data.is_gallery_upload = false;
                apis.delete_content($(this));
            });

            // remove error display
            $('.post-reg-content #username').on('focus.'+data.event_namespace, function(e) {
                handlers.remove_username_error();
            });

            var _picker_row_size = GP.sdata.is_mobile ? 5 : 10;
            $('#games-interest-select').selectpicker({
                maxOptions: 3,
                size:       _picker_row_size,
                liveSearch: true,
                dropupAuto: false
            });

            // Update initial count of selected interests
            $('#section-about-you input[name="interests[]"]').each(function(index) {
                if ($(this).is(':checked')) {
                    data.interest_count = data.interest_count + 1;
                }
                $('.text-count-current').text(data.interest_count);
            });

            $('#section-about-you input[name="interests[]"]').on('change.'+data.event_namespace, function(e) {
                if ($(this).val() === 'GAMES' && $(this).is(':checked')) {
                    $('#game-select-wrap').addClass('shown');
                }

                if  ($(this).val() === 'GAMES' && !$(this).is(':checked')) {
                    $('#game-select-wrap').removeClass('shown');
                }

                if (data.interest_count === _user_interests_max) {
                    if ($(this).is(':checked')) {
                        $(this).prop("checked", false);
                    } else {
                        data.interest_count = data.interest_count - 1;
                        events.update_interests_total_text();
                    }

                } else if (data.interest_count < _user_interests_max) {
                    data.interest_count = $(this).is(':checked') ? data.interest_count + 1 : data.interest_count - 1;
                    events.update_interests_total_text();
                }
            });

            document.querySelector("body").classList.add('modal-ios-keyboard-fix');

            // make sure the intended first section is displayed on setup
            if (document.getElementById('section-gender-age')) {
                events.display_section(data.section_gender_age);
            } else {
                events.display_section({
                    "item": "#section-photos-name",
                    "step": "#step-photos-name"
                });
            }
        },
        update_interests_total_text: function() {
            $('.text-count-current').text(data.interest_count);
        },
        show_photo_req: function() {
            $('.add-pic-wrap').addClass('error');
            $('.alert-no-pic').show();
        },
        remove_photo_req: function() {
            $('.add-pic-wrap').removeClass('error');
            $('.alert-no-pic').hide();
        },
        setup_content_rating: function() {
            $(document).on('click.' + data.event_namespace, '.btn-select-content-rating', function(e) {
                $('.btn-select-content-rating').removeClass('selected');
                $(this).addClass('selected');
                $('#ps-content-rating').val($(this).data('rating'));
            });
        }
    };


    var handlers = {
        add_thumb_to_silver_upgrade: function(json) {
            if (typeof json.tags != 'undefined' && $.isArray(json.tags)) {
                if ($.inArray('PRIVATE', json.tags) >= 0) {
                    return false;
                }
            }
            // browser will sometimes cache pics when uploading & deleting & show the wrong pic, rand prevents that
            var rand = Math.floor((Math.random()*1000)+1);

            // get the first unused pic space, first selector is so we dont pick up the templates
            var $tmp_pic = $('<img/>')
                .attr('src', _modal_vars.media_url + json.S)
                .attr('id', 'user-pic-' + json.content_id)
                .addClass('pic');
            var $pic_wrap = $('<div/>').addClass('pic').html($tmp_pic);

            $('.user-pic-s .add-pic').parent('.user-pic-s').first().html($pic_wrap);
            $('#photo-check').attr('class', 'success');
        },
        add_thumb_to_profile: function(json) {
            // only add pic to profile, if the user is viewing their own profile
            if (data.add_pic_to_profile) {
                // browser will sometimes cache pics when uploading & deleting & show the wrong pic, rand prevents that
                var rand = Math.floor((Math.random()*1000)+1);
                var href = "/members/user/profile/?type=profile&duid=" + user_duid + "&mid=" + json.pic_order;

                var $template = $('#clone-templates .profile-photo-wrap').clone();
                    $template.find('.profile-photo img').attr('src', _modal_vars.media_url + json.L);
                    $template.find('.profile-photo a').attr('href', href);
                    $template.find('.dropdown li a').data('picnum', json.pic_num);

                // Update profile content collection
                vent.trigger("Content:update_profile_feed", json);
            }
        },
        validate_upload: function(json) {
            // console.log('validate_upload json: ', json);

            var errors = '';
            if (!handlers.check_file_type(json)) {
                if (json.files.length && json.files[0]) {
                    // validate filetype
                    if (json.files.length && json.files[0].name) {
                        var extension = json.files[0].name.split('.').pop().toLowerCase();
                        match = false;
                        $.each(_modal_vars.allowed_filetypes, function(ext, mimetype) {
                            if (ext == extension) {
                                match = true;
                                return true; // break out of .each
                            }
                        });
                        if (!match) {
                            errors += '<p class="error">'+_modal_vars.error_messages[102]+'</p>';
                        }
                    }
                    // validate filesize
                    if (typeof json.files[0].size != 'undefined') {
                        if (json.files[0].size === 0) {
                            errors += '<p class="error">'+_modal_vars.error_messages[104]+'</p>';
                        } else if (json.files[0].size > _modal_vars.max_filesize) {
                            errors += '<p class="error">'+_modal_vars.error_messages[1]+'</p>';
                        }
                    }
                } else {
                    errors += '<p class="error">'+_modal_vars.error_messages[7]+'</p>';
                }
            }

            // show/hide error container
            var error_container = $('.error_container');
            if (errors) {
                if (error_container.is(':hidden')) {
                    error_container.show();
                }
                error_container.find('p.error').remove();
                error_container.append(errors);
                return false;
            } else {
                error_container.find('p.error').remove();
                error_container.hide();
                return true;
            }
        },
        check_file_type: function(json) {
            // var file_input = $('#content-file-input')[0].files[0],
            var file_input = json.files[0],
                image_types = /^image\/(gif|jpe?g|png|bmp)$/i,

                // This is for IE<10 because file mimetypes isn't defined in the file data
                image_names = /\.(gif|jpe?g|png|bmp)$/i,
                video_types = /^video\/(mp4|m4v|wmv|avi|mov|asf|quicktime|divx|ddat|webm|3gpp|x-flv|ogg|mpeg|mpg|flv)$/i,
                video_names = /\.(mp4|m4v|wmv|avi|mov|asf|ddat|webm|flv|3gp|ogv|mpeg|mpg|mpeg4|mp4v|divx|h264)$/i;

            if ((typeof(file_input.type) !== 'undefined' && image_types.test(file_input.type)) ||
                (typeof(file_input.name) !== 'undefined' && image_names.test(file_input.name))) {
                data.media_type = 'image';
                return true;
            } else if ((typeof(file_input.type) !== 'undefined' && video_types.test(file_input.type)) ||
                (typeof(file_input.name) !== 'undefined' && video_names.test(file_input.name))) {
                data.media_type = 'video';
                return true;
            } else {
                // events.show_post_error(js_lang.unacceptable_file_type);
            }

            return false;
        },
        // show_gallery_image_preview: function(_url, _content_id) {
        //     // show mini thumb grid view
        //     $('.add-gallery-media').addClass('has-gallery-media');

        //     // find the next empty grid item and add image preview
        //     $('.add-media-item').each(function(index) {
        //         if (!$(this).hasClass('has-media')) {
        //             $(this).addClass('has-media')
        //             .attr('data-content_id', _content_id)
        //             .attr('data-content_type', 'image');

        //             $(this).find('.img-preview').css('background-image', 'url(' + _url + ')');
        //             return false;
        //         }
        //     });
        // },
        show_image_preview: function(_url, _content_id) {
            // find the next empty grid item and add image preview
            $('.add-media-item').each(function(index) {
                if (!$(this).hasClass('has-media')) {
                    $(this).addClass('has-media')
                    .attr('data-content_id', _content_id)
                    .attr('data-content_type', 'image');

                    $(this).find('.img-preview').css('background-image', 'url(' + _url + ')');
                    return false;
                }
            });
        },
        remove_username_error: function() {
            $('.modal-form-group.username').removeClass('has-error');
        },
        reset_nav_pics: function() {
            var ph = 'https://cachemd.fling.com/images/thumbs/nopic-ALL-S.jpg';
            $("#mem-photo-t").attr('src', ph);
            $("#mem-photo-s").attr('src', ph);
            $("#profile-menu-link img").attr('src', ph);
        }
    };

    this.addInitializer(function() {
        data.init();
        self.vent.on(self.moduleName+":setup_modal", events.setup_modal, this);
    });
});
